import CounterpartyContactsForm from "components/cargoOwners/contactsForm";
import DropdownBtn from "components/shared/dropdown";
import List from "components/shared/list";
import Loader from "components/shared/loader";
import Select, { customStyles } from "components/shared/select";
import { dateTimeToView, dateToView } from "helpers/date";
import {
    documentBusinessTypesEnum,
    universalDocumentSendStatuses,
    universalDocumentSendStatusesEnum,
    universalDocumentStatuses,
} from "helpers/enums";
import { paths } from "helpers/paths";
import { tableContainer } from "helpers/redux";
import { downloadURI, enumLabel } from "helpers/system";
import Tooltip from "rc-tooltip";
import React, { lazy, Suspense, useState } from "react";
import { CustomScroll } from "react-custom-scroll";
import { Link } from "react-router-dom";
import { delItem, getDocumentFile, setSendStatus, setStatus } from "sources/books/finance";

const PdfPreview = lazy(() => import("components/shared/fileBody/pdfPreview.js"));

function DocumentStatus(props) {
    const { item, changeStatusHandle } = props;
    const [editMode, setEditMode] = useState(false);

    return (
        <>
            {editMode ? (
                <Select
                    inputProps={{ name: "status" }}
                    value={item.status}
                    options={universalDocumentStatuses}
                    onChange={(data) => (data.value ? changeStatusHandle(data) : setEditMode(false))}
                    styles={{ ...customStyles }}
                />
            ) : (
                <div className="small">
                    <i className="link icon-uEA10-pen pr-1" onClick={() => setEditMode(true)} />
                    {enumLabel(universalDocumentStatuses, item.status)}
                    {item.message}
                </div>
            )}
            {item.updatedAt && <div className="small text-muted">{dateTimeToView(item.updatedAt)}</div>}
        </>
    );
}

class DocumentsList extends List {
    getList = ({ getList, params }) => getList({ ...params, id: this.props.bid.id, type: this.props.type });

    renderTableRow = (item, index) => {
        const { id, isGenerating } = item;
        const changeStatusHandle = ({ name, value }) => {
            this.setState({ loading: true });
            switch (name) {
                case "status":
                    return setStatus({ id, status: value }).then((res) => {
                        if (res) {
                            this.getList(this.props);
                        }
                        this.setState({ loading: false });
                    });
                case "sendStatus":
                    return setSendStatus({ id, status: value }).then((res) => {
                        if (res) {
                            this.getList(this.props);
                        } else {
                            this.props.addModal({
                                name: "default",
                                windowMod: "sm",
                                title: "Заполните контактные данные",
                                CustomBody: CounterpartyContactsForm,
                                bodyData: { counterpartyId: item.counterparty?.id },
                            });
                        }
                        this.setState({ loading: false });
                    });
            }
            this.setState({ loading: false });
        };

        const downloadFile = (extension) =>
            getDocumentFile(item.id, extension).then(
                (res) => res && downloadURI(res.accessUrlLink, res.originalFileName),
            );
        const items =
            this.props.type === documentBusinessTypesEnum.Contract
                ? [
                      { text: "DOCX", action: () => downloadFile("docx") },
                      { text: "Загруженный XML", action: () => downloadFile("xml") },
                  ]
                : [
                      { text: "PDF", action: () => downloadFile("pdf") },
                      { text: "УПД XML", action: () => downloadFile("utd.xml") },
                  ];

        const showPdf = () => {
            getDocumentFile(item.id, "pdf").then((res) => {
                this.props.addModal({
                    name: "default",
                    mod: "pdf",
                    withoutHeader: true,
                    CustomBody: (props) => (
                        <Suspense fallback={<Loader />}>
                            <PdfPreview {...props} />
                        </Suspense>
                    ),
                    bodyData: { accessUrlLink: res.accessUrlLink },
                });
            });
        };

        const removeItem = () => {
            this.setState({ loading: true });
            this.props.addModal({
                name: "confirm",
                title: "Вы действительно хотите удалить документ?",
                onSuccessAction: () => this.props.mergeParams({}),
                onCloseAction: () => this.setState({ loading: false }),
                buttons: { confirm: "Да", cancel: "Нет" },
                action: () => delItem({ id: item.id }),
            });
        };

        return (
            <tr key={id}>
                <td>{this.props.params.start + index + 1}</td>
                <td>
                    {isGenerating ? (
                        item.name
                    ) : (
                        <>
                            <Link to={paths.financesDocumentsShow(item.id)} target="blank">
                                {item.name}
                            </Link>
                            <div className="small text-muted">
                                {this.props.type !== documentBusinessTypesEnum.Contract && (
                                    <small className="link mr-4" onClick={showPdf}>
                                        <i className="icon-uEA49-eye icon-inline pr-1" />
                                        Просмотреть
                                    </small>
                                )}
                                {dateToView(item.date)}
                            </div>
                        </>
                    )}
                </td>
                <td>
                    {!isGenerating && (
                        <>
                            <div className="pb-1">{enumLabel(universalDocumentSendStatuses, item.sendStatus)}</div>
                            <div
                                className="btn btn-xs btn-outline-primary"
                                onClick={() =>
                                    changeStatusHandle({
                                        name: "sendStatus",
                                        value: universalDocumentSendStatusesEnum.SentToEmail,
                                    })
                                }
                            >
                                Отправить на почту
                            </div>
                            {item.sendAt && <div className="small text-muted">{dateTimeToView(item.sendAt)}</div>}
                        </>
                    )}
                </td>
                <td>
                    {isGenerating ? (
                        <Tooltip placement="bottom" overlay="Формирование документа может занимать до 5 секунд">
                            <div className="d-flex align-items-center">
                                <span className="icon-uEA79-spinner animation-rspin pr-1" />В обработке
                            </div>
                        </Tooltip>
                    ) : (
                        <DocumentStatus item={item} changeStatusHandle={changeStatusHandle} />
                    )}
                </td>
                <td>
                    {!isGenerating && (
                        <DropdownBtn
                            cname="btn btn-xs btn-outline-primary"
                            text="Скачать"
                            items={items}
                            contentCname="font-size-14"
                        />
                    )}
                    <div>
                        <div className="btn btn-xs btn-outline-danger" onClick={removeItem}>
                            Удалить
                        </div>
                    </div>
                </td>
            </tr>
        );
    };

    renderItems = () => {
        const { items } = this.props;

        return items && items.length ? (
            items.map(this.renderTableRow)
        ) : (
            <tr>
                <td colSpan={5}>
                    <span className="list__body-empty">Не найдено</span>
                </td>
            </tr>
        );
    };

    render() {
        return (
            <>
                <div className="flex-1 overflow-hidden">
                    <CustomScroll heightRelativeToParent="100%">
                        <div className="container-fluid py-2 table-responsive h-100">
                            {this.props.isLoadingList || this.state?.loading ? (
                                <Loader prefix="absolute-center" />
                            ) : (
                                <table className="table table-sm table-bordered">
                                    <thead>
                                        <tr>
                                            <th />
                                            <th>Документ</th>
                                            <th>Статус отправки</th>
                                            <th>Статус</th>
                                            <th />
                                        </tr>
                                    </thead>
                                    <tbody>{this.renderItems()}</tbody>
                                </table>
                            )}
                        </div>
                    </CustomScroll>
                </div>
                {this.renderPagination()}
            </>
        );
    }
}

export default {
    Bid: tableContainer(DocumentsList, "finances-bid-documents"),
    DistributionBid: tableContainer(DocumentsList, "finances-distribution-bid-documents"),
};
